import React, { useState, useCallback, useMemo } from 'react';
import Attachment from 'components/ui/Attachment';
import { atualizarIniciativa } from 'services/iniciativa-elbb.service';
import { uploadFile } from 'services/file.service';

interface ModalEditarInscricaoProps {
  iniciativaOriginal: any;
  onSave: () => void;
  onClose: () => void;
}

export const ModalEditarInscricao: React.FC<ModalEditarInscricaoProps> = ({
  iniciativaOriginal,
  onSave,
  onClose,
}) => {
  const currentDocumento = useMemo(() => iniciativaOriginal?.documento || [], [iniciativaOriginal]);

  const [videoUrl, setVideoUrl] = useState(() => {
    const video = currentDocumento.find((d: any) => d?.type === 'video');
    return video?.file || '';
  });
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = useCallback(async () => {
    setIsSaving(true);
    setError('');
    try {
      const documento: any[] = [];
      if (videoUrl) {
        documento.push({ file: videoUrl, type: 'video' });
      }

      const existingPdf = currentDocumento.find((d: any) => d?.type === 'file' && d?.file);
      if (pdfFile) {
        const fileData = await uploadFile(pdfFile);
        documento.push({ file: fileData.url, nameFile: fileData.filename, type: 'file' });
      } else if (existingPdf) {
        documento.push(existingPdf);
      }

      await atualizarIniciativa({
        ...iniciativaOriginal,
        documento,
      });

      onSave();
    } catch (err) {
      console.error('Erro ao atualizar inscrição:', err);
      setError('Erro ao salvar alterações. Tente novamente.');
    } finally {
      setIsSaving(false);
    }
  }, [videoUrl, pdfFile, iniciativaOriginal, currentDocumento, onSave]);

  return (
    <div className="bg-white rounded-2xl p-5 w-[680px] max-w-[90vw]">
      <h2 className="text-lg font-bold text-[#1e3a5f] mb-4">Editar Inscrição</h2>

      <div className="mb-4">
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Vídeo e Documento
        </label>
        <Attachment
          currentDocument={currentDocumento}
          onFileSelect={(file) => setPdfFile(file)}
          onVideoSelect={setVideoUrl}
          onProgressComplete={() => {}}
          allowedTypes={['application/pdf']}
          maxFizeSize={3}
        />
      </div>

      {error && (
        <p className="text-red-500 text-sm mb-3">{error}</p>
      )}

      <div className="flex items-center justify-end gap-3">
        <button
          onClick={onClose}
          disabled={isSaving}
          className="bg-transparent border border-gray-300 text-gray-600 rounded-lg px-6 py-2.5 text-sm font-bold cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40"
        >
          CANCELAR
        </button>
        <button
          onClick={handleSave}
          disabled={isSaving || !videoUrl}
          className="bg-[#f5c518] text-[#1e3a5f] border-0 rounded-lg px-6 py-2.5 text-sm font-extrabold cursor-pointer hover:bg-[#e6b800] transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {isSaving ? 'SALVANDO...' : 'SALVAR ALTERAÇÕES'}
        </button>
      </div>
    </div>
  );
};
